// extracted by mini-css-extract-plugin
export default {"wrapper":"sFg0aptoCZmna78mBUpw","label":"j8FY4c858IxwFQvAiuVs","type":"qHp6Pp8lojJ_x4Gm_3uH"};